import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const MosaicCardInfoContainer = styled.div<{ info: boolean }>`
  border-radius: 0 0 ${Screen.widthRatio * 19}px ${Screen.widthRatio * 19}px;
  display: flex;
  flex-direction: column;
  height: ${Screen.widthRatio * 105}px;
  justify-content: ${(props) => (props.info ? 'end' : 'start')};
  margin-left: ${Screen.widthRatio * 30}px;
  margin-top: ${(props) => Screen.widthRatio * (props.info ? 38 : 74)}px;
  position: absolute;
  width: ${Screen.widthRatio * 295}px;
`;

export default MosaicCardInfoContainer;
